/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Pin(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Pin',
      'aria-hidden': true,
      focusable: false,
      width:  17 * scale,
      height: 17 * scale,
      viewBox: '0 0 17 17',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M13.336 6.492 11.42 8.408c1.06 1.96.346 3.544-.153 4.294a.5.5 0 0 1-.77.067L4.23 6.5a.5.5 0 0 1 .066-.77c.75-.498 2.335-1.214 4.296-.15l1.912-1.912c-.336-1.026-.145-1.956.07-2.552A.5.5 0 0 1 11.4.942l4.652 4.653a.5.5 0 0 1-.174.822c-.594.215-1.52.405-2.54.075zM5.596 9.99l1.414 1.414-5.285 4.625A.544.544 0 0 1 1 16a.535.535 0 0 1-.03-.725L5.597 9.99z","fill":"currentColor"}))
}
